import { computed } from "vue";

export const useSpProgress = (props) => {
  const isDeterminate = computed(() => props.value != null);
  const clampedValue = computed(() => (isDeterminate.value ? Math.max(0, Math.min(100, props.value)) : 0));

  return {
    isDeterminate,
    clampedValue,
  };
};
